import React, { useState } from 'react';
import { AccordionItem } from '..';
import './Accordion.css';

export interface Props {
  category: string;
  elements: Array<AccordionItem>;
}

export interface AccordionItem {
  heading: string;
  text: string;
}

export default function Accordion(props: Props) {
  const { elements = [], category } = props;
  const [activeItem, setActiveItem] = useState('');
  const handleClick = (id: string): void => {
    if (activeItem === id) {
      setActiveItem('');
    } else {
      setActiveItem(id);
    }
  };

  return (
    <div className="accordion">
      {elements.map((element, index) => {
        const { heading, text } = element;
        const key = `${index}-${category}`;
        return (
          <AccordionItem
            key={key}
            hasBar={index !== 0}
            heading={heading}
            text={text}
            isExpanded={activeItem === key}
            onClick={() => handleClick(key)}
          />
        );
      })}
    </div>
  );
}
